import { Checkbox, Table, TableThProps } from '@mantine/core';
import clsx from 'clsx';
import { useUnit } from 'effector-react';
import { forwardRef } from 'react';
import { RegistryModel, Row } from 'shared/lib';

export type RegistryTableThCheckboxProps = TableThProps;

export const createRegistryTableThCheckbox = <
	TRow extends Row,
	TFilters extends Record<string, unknown>,
	TError,
	TAdditionalData = unknown,
>(
	model: RegistryModel<TRow, TFilters, TError, TAdditionalData>,
) => {
	const RegistryTableThCheckbox = forwardRef<HTMLTableCellElement, RegistryTableThCheckboxProps>(
		({ className, onClick, ...props }, ref) => {
			const [allSelected, selectAll, deselectAll] = useUnit([
				model.$allSelected,
				model.allRowsSelected,
				model.allRowsDeselected,
			]);

			return (
				<Table.Th
					ref={ref}
					className={clsx('registry-table-th-checkbox', className)}
					{...props}
				>
					<Checkbox
						data-test-id='registry-table-th-checkbox'
						checked={allSelected}
						onChange={() => (allSelected ? deselectAll() : selectAll())}
					/>
				</Table.Th>
			);
		},
	);

	return RegistryTableThCheckbox;
};
